﻿class CutOff extends HTMLElement {
  connectedCallback() {
    const content = this.firstElementChild;
    const toggle = document.getElementById(this.getAttribute('toggle'));
    const toggleOpenText = this.getAttribute('toggle-open-text');
    const toggleDefaultText = toggle.innerText;
    toggle.addEventListener('click', () => {
      this.toggleAttribute('open');
      if (toggle.innerText == toggleDefaultText) {
        toggle.innerText = toggleOpenText;
      } else {
        toggle.innerText = toggleDefaultText;
      }
    });
  }
}

customElements.define('cut-off', CutOff);
